var map = {
	"./icon_down.png": 4849,
	"./icon_nochange.png": 4988,
	"./icon_rate.png": 2767,
	"./icon_sugar.png": 583,
	"./icon_sugar_gery.png": 4711,
	"./icon_up.png": 9490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7974;